const toggleModal = (targetModal, toggle) => {
  targetModal.classList.toggle('show', toggle);
};

attachEvent('.product-card__link', 'click', (el) => {
  const parent = el.target.closest('.products-list');
  const parentCard = el.target.closest('.product-card');
  const modalIndex = parentCard.getAttribute('data-target');
  const targetModal = parent.querySelector(`[data-modal="${modalIndex}"]`);
  toggleModal(targetModal, true);
  el.preventDefault();
});

attachEvent('.product-modal__back-button', 'click', (el) => {
  const parentModal = el.target.closest('.product-modal');
  toggleModal(parentModal, false);
  el.preventDefault();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalElem = document.querySelectorAll('.product-modal');
    const list = document.querySelectorAll('.products-list__list');

    modalElem.forEach((el) => {
      el.classList.remove('show');
    });

    list.forEach((el) => {
      el.classList.remove('hide');
    });
  }
});
